// extracted by mini-css-extract-plugin
export default {"column":"ConferenceDetailsComponent_column__CY4+q","body":"ConferenceDetailsComponent_body__rTi1-"};